export const buildClusterScopedPropertyKey = (
  clusterName: string | undefined,
  propertyKey: string
) => {
  if (!propertyKey) {
    return propertyKey
  }
  return clusterName ? `${clusterName}.${propertyKey}` : propertyKey
}

export const readClusterScopedProperty = <T extends Record<string, any> | undefined>(
  properties: T,
  clusterName: string | undefined,
  propertyKey: string
) => {
  if (!properties) {
    return undefined
  }
  const scopedKey = buildClusterScopedPropertyKey(clusterName, propertyKey)
  if (scopedKey && scopedKey in properties) {
    return (properties as Record<string, any>)[scopedKey]
  }
  return (properties as Record<string, any>)[propertyKey]
}
